import React from 'react';
import { Card, Badge, Row, Col } from 'react-bootstrap';
import { Calendar, Home, User, Image as ImageIcon } from 'lucide-react';
import { Reservation, House } from '../../services/types';

interface ReservationPhotoCardProps {
    reservation: Reservation;
    house: House | undefined;
    checkInCount: number;
    checkOutCount: number;
    onClick: () => void;
}

const ReservationPhotoCard: React.FC<ReservationPhotoCardProps> = ({
    reservation,
    house,
    checkInCount,
    checkOutCount,
    onClick,
}) => {
    const totalPhotos = checkInCount + checkOutCount;
    const isMobile = window.innerWidth < 768;

    return (
        <Card
            className="h-100 shadow-sm hover-shadow"
            style={{ cursor: 'pointer', transition: 'all 0.3s ease' }}
            onClick={onClick}
        >
            <Card.Body>
                <div className="d-flex justify-content-between align-items-start mb-3">
                    <div className="flex-grow-1">
                        <h6 className="mb-2 d-flex align-items-center">
                            <User size={18} className="me-2 text-primary" />
                            {reservation.name_first_guess || 'Guest'}
                        </h6>
                        <p className="text-muted small mb-2 d-flex align-items-center">
                            <Home size={16} className="me-2" />
                            {house?.name || house?.address || 'Unknown'}
                        </p>
                        <p className="text-muted small mb-0 d-flex align-items-center">
                            <Calendar size={16} className="me-2" />
                            {reservation.check_in_date} - {reservation.check_out_date}
                        </p>
                    </div>
                    <Badge
                        bg={totalPhotos > 0 ? 'primary' : 'secondary'}
                        className="d-flex align-items-center gap-1"
                        style={{ fontSize: isMobile ? '0.75rem' : '0.85rem' }}
                    >
                        <ImageIcon size={14} />
                        {totalPhotos}
                    </Badge>
                </div>

                <Row className="g-2 mt-2">
                    <Col xs={6}>
                        <div
                            className="text-center p-2 rounded"
                            style={{
                                backgroundColor: checkInCount > 0 ? '#e7f3ff' : '#f8f9fa',
                                border: `1px solid ${checkInCount > 0 ? '#0d6efd' : '#dee2e6'}`,
                            }}
                        >
                            <div className="small text-muted">Check-in</div>
                            <div className="fw-bold" style={{ color: checkInCount > 0 ? '#0d6efd' : '#6c757d' }}>
                                {checkInCount} {checkInCount === 1 ? 'photo' : 'photos'}
                            </div>
                        </div>
                    </Col>
                    <Col xs={6}>
                        <div
                            className="text-center p-2 rounded"
                            style={{
                                backgroundColor: checkOutCount > 0 ? '#fff3e0' : '#f8f9fa',
                                border: `1px solid ${checkOutCount > 0 ? '#fd7e14' : '#dee2e6'}`,
                            }}
                        >
                            <div className="small text-muted">Check-out</div>
                            <div className="fw-bold" style={{ color: checkOutCount > 0 ? '#fd7e14' : '#6c757d' }}>
                                {checkOutCount} {checkOutCount === 1 ? 'photo' : 'photos'}
                            </div>
                        </div>
                    </Col>
                </Row>

                {totalPhotos === 0 && (
                    <div className="text-center text-muted small mt-3">
                        No photos uploaded yet
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default ReservationPhotoCard;
